import { MouseEvent, ReactNode } from 'react'
import TouchableOpacity from '../TouchableOpacity'
import styles from './style'

interface ListRowActionProps {
  onClick: (e: MouseEvent<HTMLDivElement>) => void
  disabled?: boolean
  children: ReactNode
}

function ListRowAction({ onClick, disabled = false, children }: ListRowActionProps) {
  return (
    <TouchableOpacity
      disabled={disabled}
      style={styles.action}
      onClick={e => {
        e.stopPropagation()
        onClick(e)
      }}
    >
      {children}
    </TouchableOpacity>
  )
}

export default ListRowAction
